import React, { useEffect, useState } from "react";
import { sendOtp, verifyOtp } from "../api/signerApi";

const RESEND_SECONDS = 30;

export default function OtpVerification({ token, onVerified }) {
  const [otp, setOtp] = useState("");
  const [sending, setSending] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [cooldown, setCooldown] = useState(0);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (cooldown <= 0) return;

    const timer = setInterval(() => {
      setCooldown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [cooldown]);

  const handleSendOtp = async () => {
    if (cooldown > 0) return;

    try {
      setSending(true);
      setMessage("");

      const res = await sendOtp(token);
      setOtpSent(true);
      setCooldown(RESEND_SECONDS);

      if (res?.data?.otpCode) {
        setMessage(`OTP sent.`);
      } else {
        setMessage("OTP sent successfully.");
      }
    } catch (e) {
      setMessage("Failed to send OTP.");
    } finally {
      setSending(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp.trim()) {
      setMessage("Enter OTP.");
      return;
    }

    try {
      setVerifying(true);
      setMessage("");

      await verifyOtp({
        accessToken: token,
        otpCode: otp,
      });

      setMessage("OTP verified successfully.");
      onVerified();
    } catch (e) {
      setMessage("Invalid or expired OTP.");
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="card">
      <h3 className="card-title">Send OTP</h3>
      <p className="card-subtitle">
        Click the button below to receive a verification code.
      </p>

      {message && (
        <div
          className={
            message.toLowerCase().includes("failed") ||
            message.toLowerCase().includes("invalid")
              ? "error-banner"
              : "info-banner"
          }
          style={{ marginBottom: 14 }}
        >
          {message}
        </div>
      )}

      <div className="form-grid">
        <button
          className="btn btn-primary"
          onClick={handleSendOtp}
          disabled={sending || cooldown > 0}
        >
          {sending
            ? "Sending OTP..."
            : otpSent && cooldown > 0
              ? `Resend OTP in ${cooldown}s`
              : otpSent
                ? "Resend OTP"
                : "Send OTP"}
        </button>

        {otpSent && (
          <>
            <div>
              <label className="label">
                OTP Code <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="input"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP"
              />
            </div>

            <button
              className="btn btn-primary"
              onClick={handleVerifyOtp}
              disabled={verifying}
            >
              {verifying ? "Verifying..." : "Verify OTP"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
